export default "__VITE_ASSET__d7a16017__"